import React from "react";
import { FluentButton } from "../../../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import NothingHere from "../../../../../../assets/Illustrations/NothingHere.svg";
import { ViewFormsItem } from "./view-forms-item";
import PropTypes from "prop-types";

export const ViewForms = ({
  setFormView,
  allForms,
  RenameForm,
  DeleteForm,
  AddForm,
}) => {
  return (
    <div className="view-forms-content">
      {allForms?.data?.length > 0 && (
        <div className="view-forms-list">
          <div className="view-forms-list-head">Forms</div>
          <div className="view-forms-list-content">
            {allForms.data?.map((form) => (
              <ViewFormsItem
                key={form.DisplayOrder}
                allFormNames={allForms.data.map((form) => {
                  return { Label: form.Label, DisplayOrder: form.DisplayOrder };
                })}
                setFormView={setFormView}
                form={form}
                RenameForm={RenameForm}
                DeleteForm={DeleteForm}
              ></ViewFormsItem>
            ))}
          </div>
        </div>
      )}
      <div className="view-forms-add">
        <FluentButton
          icon={
            <FluentUiIcon name={"AddRegular"} color={"#212121"} size={18} />
          }
          onClick={AddForm}
          text={"Add new Form"}
        />
      </div>
      {(!allForms?.data || allForms?.data?.length === 0) && (
        <div className="view-forms-no-form">
          <img
            className="view-forms-no-form-image"
            src={NothingHere}
            alt={"NothingHere"}
          ></img>
          <div className="view-forms-no-form-head">Create your first Form</div>
          <div className="view-forms-no-form-foot">
            To get started, click the “Add new Form” button.
          </div>
        </div>
      )}
    </div>
  );
};

ViewForms.propTypes = {
  setFormView: PropTypes.func,
  allForms: PropTypes.object,
  RenameForm: PropTypes.func,
  DeleteForm: PropTypes.func,
  AddForm: PropTypes.func,
};
